import { api } from "@/lib/api";

const toBytes = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
// iOS delivers web push only to the app installed on the Home screen
export const pushAvailable = () => pushSupported() && (!isIOS() || isStandalone());
export const pushPermission = () => (pushSupported() ? Notification.permission : "unsupported");

// Must be called from a click (required by iOS); links the device to the user and/or the booking session
export async function enablePush(sessionId) {
  if (!pushAvailable()) throw new Error(isIOS() ? "Installa prima l'app nella schermata Home (Condividi → Aggiungi a Home)" : "Il tuo browser non supporta le notifiche");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso notifiche negato. Puoi riattivarlo dalle impostazioni del browser.");
  const reg = (await navigator.serviceWorker.getRegistration("/")) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/config");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.public_key) });
  }
  await api.post("/push/subscriptions", { subscription: sub.toJSON(), session_id: sessionId || null });
  return true;
}
